// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"87217f37","757":"a44373ee"}[chunkId] + ".chunk.js";
};